var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMoney2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5c-3 0-5 1.5-5 5v7c0 3.5 2 5 5 5h10c3 0 5-1.5 5-5v-7c0-3.5-2-5-5-5H7zM3.5 15.02V8.98C6.09 8.86 7 7.82 7 5h10c0 2.82.91 3.86 3.5 3.98V15.02c-2.59.12-3.5 1.16-3.5 3.98H7c0-2.82-.91-3.86-3.5-3.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMoney2);
export default __webpack_public_path__ + "static/media/vuesax-bold-money-2.aab1e646d1c9b375e6bebded8179551a.svg";
export { ForwardRef as ReactComponent };